module.exports = __webpack_public_path__ + "static/media/feedback.4efcec27.svg";